import { render, staticRenderFns } from "./PatientHistory.vue?vue&type=template&id=36873e0f&"
import script from "./PatientHistory.vue?vue&type=script&lang=js&"
export * from "./PatientHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports